import additionalResourcesService from '../../services/AdditionalResourcesService';

const fullscreenIframeSelector = {

    selectProps(state) {
        const { settings, assessment, parentTest, ui } = state;

        return {
            additionalResources: additionalResourcesService.getAdditionalResources(settings, assessment, parentTest),
            currentSelectedTitle: ui?.currentIframeTitle ? ui.currentIframeTitle : '',
        };
    },
};

export default fullscreenIframeSelector;
